module.exports = __webpack_public_path__ + "img/aq.c4953241.png";